// Wallet (claimed coupons) + deal watchlist API client (web). Talks to the
// shared Django endpoints: GET /api/wallet/, POST /api/wallet/<id>/redeem/,
// GET|POST /api/watchlist/, PATCH|DELETE /api/watchlist/<id>/. Shapes mirror
// views_coupons.py / views_watchlist.py.

import axios from 'axios';
import API_BASE_URL from '../config';

const BASE_URL = `${API_BASE_URL}/api`;

const authHeaders = () => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) { window.location.href = '/login'; throw new Error('No access token'); }
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
};

const on401 = (err) => {
  if (err.response?.status === 401) {
    localStorage.removeItem('accessToken');
    window.location.href = '/login';
  }
};

// GET /api/wallet/ → wallet coupon[] (claimed + redeemed)
export const getWallet = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/wallet/`, { headers: authHeaders() });
    return res.data.wallet || [];
  } catch (err) {
    console.error('❌ Error fetching wallet:', err.response?.data || err.message);
    on401(err);
    throw err;
  }
};

// POST /api/wallet/<id>/redeem/ → { status, redeemed_at }
export const redeemWalletCoupon = async (walletId) => {
  try {
    const res = await axios.post(`${BASE_URL}/wallet/${walletId}/redeem/`, {}, { headers: authHeaders() });
    return res.data;
  } catch (err) {
    on401(err);
    throw err;
  }
};

// GET /api/watchlist/ → entries[]
export const getWatchlist = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/watchlist/`, { headers: authHeaders() });
    return res.data.entries || [];
  } catch (err) {
    console.error('❌ Error fetching watchlist:', err.response?.data || err.message);
    on401(err);
    throw err;
  }
};

// POST /api/watchlist/ → { entry }
export const addWatchlist = async ({ item_text, store = '', target_price = '' }) => {
  try {
    const res = await axios.post(`${BASE_URL}/watchlist/`, { item_text, store, target_price }, { headers: authHeaders() });
    return res.data.entry;
  } catch (err) {
    on401(err);
    throw err;
  }
};

// PATCH /api/watchlist/<id>/ → { entry }
export const updateWatchlist = async (id, patch) => {
  try {
    const res = await axios.patch(`${BASE_URL}/watchlist/${id}/`, patch, { headers: authHeaders() });
    return res.data.entry;
  } catch (err) {
    on401(err);
    throw err;
  }
};

// DELETE /api/watchlist/<id>/ → { ok }
export const deleteWatchlist = async (id) => {
  try {
    const res = await axios.delete(`${BASE_URL}/watchlist/${id}/`, { headers: authHeaders() });
    return res.data;
  } catch (err) {
    on401(err);
    throw err;
  }
};

// ── shared coupon discount label ───────────────────────────────────────────
export const discountLabel = (c) => {
  const type = c.discount_type;
  const v = c.discount_value;
  if (type === 'percent') return `${v}% OFF`;
  if (type === 'flat') return `$${v} OFF`;
  if (type === 'bogo') return 'BOGO';
  if (type === 'free_item') return 'FREE ITEM';
  return v ? `$${v} OFF` : 'DEAL';
};
